var _g, _g2, _g3, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 50,
    viewBox: "0 0 28 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vehicle_svg__filter0_f_1_149)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.375,
    cy: 41.612,
    r: 1.875,
    fill: "#FE585E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vehicle_svg__filter1_f_1_149)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.625,
    cy: 41.61,
    r: 1.875,
    fill: "#FE585E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vehicle_svg__filter2_dd_1_149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 43.504c-7.5 0-10-1.25-10-7.495V16.004c0-6.25 2.5-7.5 10-7.5s10 1.25 10 7.5v20.005c0 6.245-2.5 7.495-10 7.495z",
    fill: "#666"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 36.006c0 4.995 1.25 6.245 8.75 6.245s8.75-1.25 8.75-6.245V21.001c0-5-1.25-6.25-8.75-6.25s-8.75 1.25-8.75 6.25v15.005zm1.25.001c0 3.745.625 4.995 7.5 4.995s7.5-1.25 7.5-4.995V24.752c0-3.75-.625-5-7.5-5s-7.5 1.25-7.5 5v11.255z",
    fill: "#000",
    fillOpacity: 0.43
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.774 11.274c-.24-.648-1.488-.795-2.788-.33-1.3.465-2.16 1.367-1.92 2.015.24.647 1.488.795 2.788.33 1.3-.466 2.16-1.368 1.92-2.015zm6.453 0c.24-.648 1.487-.795 2.787-.33 1.3.465 2.16 1.367 1.92 2.015-.24.647-1.488.795-2.788.33-1.3-.466-2.159-1.368-1.92-2.015z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 0H28l-5.269 10.777c-1.145-1.458-3.142-2.044-6.295-2.215L12.25 0z",
    fill: "url(#vehicle_svg__paint0_linear_1_149)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h15.75l-4.186 8.562c-3.153.17-5.15.757-6.295 2.215L0 0z",
    fill: "url(#vehicle_svg__paint1_linear_1_149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vehicle_svg__filter0_f_1_149",
    x: 2.5,
    y: 35.737,
    width: 11.75,
    height: 11.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1_149"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vehicle_svg__filter1_f_1_149",
    x: 13.75,
    y: 35.735,
    width: 11.75,
    height: 11.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1_149"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vehicle_svg__filter2_dd_1_149",
    x: 0,
    y: 4.504,
    width: 28,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_149"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1_149",
    result: "effect2_dropShadow_1_149"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1_149",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vehicle_svg__paint0_linear_1_149",
    x1: 19.6,
    y1: 0,
    x2: 19.6,
    y2: 12.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vehicle_svg__paint1_linear_1_149",
    x1: 7.35,
    y1: 0,
    x2: 7.35,
    y2: 12.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
export default SvgVehicle;